export const LOCATION_SEARCH_RESULTS = '/search';
export const STORAGE_LAST_SEARCHES_PATH = 'OTT/activities/lastSearches/v3';
export const FORM_NAME = 'activities_search_form';

export const CITY_PARAMS = {
  ID: 'id',
  NAME: 'name',
  COUNTRY: 'country',
  ACTIVITIES_COUNT: 'activitiesCount',
  SIGHT_ID: 'sightId',
};

export const DATE_PARAMS = {
  START_DATE: 'start_date',
  END_DATE: 'end_date',
};

export const DEFAULT_SUGGEST_CITIES = [
  {
    id: 1179,
    name: 'Санкт-Петербург',
  },
  {
    id: 2376,
    name: 'Москва',
  },
  {
    id: 6798,
    name: 'Золотое кольцо',
  },
];

export const SEARCH_FORM_FIELD = 'city';
export const DATES_FORM_FIELD = 'dates';

export const DEPTH_OF_SEARCH_IN_DAYS = 90;
